module.exports = __webpack_public_path__ + "img/pin.2263c818.svg";